import { Avatar } from "@material-ui/core";

export default Avatar;
